import {
  EXCHANGE_TYPE,
  FLAT_EXCHANGE,
  OUTRIGHT,
  SECOND_EXCHANGE,
  THIRD_EXCHANGE
} from "MODULES/SalesOrders/constants";
import { INTERNAL_OUTRIGHT } from "MODULES/inventories/constants";
import T from "prop-types";
import React from "react";

export const ExchangeIcon = ({ lineItem }) => {
  const exchangeTypes = [
    { key: EXCHANGE_TYPE, value: null, text: 1 },
    { key: FLAT_EXCHANGE, value: true, text: "F" },
    { key: EXCHANGE_TYPE, value: SECOND_EXCHANGE, text: 2 },
    { key: EXCHANGE_TYPE, value: THIRD_EXCHANGE, text: 3 },
    { key: OUTRIGHT, value: true, text: "O" },
    { key: INTERNAL_OUTRIGHT, value: true, text: "io" }
  ];

  const filteredVal = exchangeTypes.filter(
    f => lineItem[f.key] === f.value && lineItem.purchase_for_exchange
  );

  if (filteredVal.length === 0) {
    return null;
  }

  return (
    <span className="fa-stack fa-1x">
      <i className="fa fa-lg fa-circle text-success" />
      <span className="fa fa-stack-1x exchange-circle-text">
        {filteredVal[filteredVal.length - 1].text}
      </span>
    </span>
  );
};

ExchangeIcon.propTypes = {
  lineItem: T.shape({ purchase_for_exchange: T.bool, exchange_type: T.string })
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/ExchangeIcon.jsx